var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "fade-transition",
        { attrs: { duration: 250, mode: "out-in" } },
        [
          _vm.getComponentId("landing") === _vm.activeComponent.id
            ? _c("landing", { on: { continue: _vm.incrementActiveComponent } })
            : _vm._e(),
          _vm._v(" "),
          _vm.getComponentId("questionnaire") === _vm.activeComponent.id
            ? _c("questionnaire", {
                attrs: {
                  questionnaire: _vm.questionnaire,
                  answers: _vm.form.data.answers,
                  initialQuestionIndex:
                    _vm.views.questionnaire.initialQuestionIndex
                },
                on: {
                  "update:answers": function($event) {
                    return _vm.$set(_vm.form.data, "answers", $event)
                  },
                  back: function($event) {
                    _vm.form.data.answers = []
                    _vm.decrementActiveComponent()
                  },
                  continue: _vm.incrementActiveComponent
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.getComponentId("hearingTestConfiguration") ===
          _vm.activeComponent.id
            ? _c("hearing-test-configuration", {
                attrs: {
                  user: _vm.form.data.user,
                  headphone: _vm.form.data.headphone
                },
                on: {
                  "update:user": function($event) {
                    return _vm.$set(_vm.form.data, "user", $event)
                  },
                  "update:headphone": function($event) {
                    return _vm.$set(_vm.form.data, "headphone", $event)
                  },
                  continue: _vm.incrementActiveComponent
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.getComponentId("hearingTestCalibration") ===
          _vm.activeComponent.id
            ? _c("hearing-test-calibration", {
                attrs: { handler: _vm.handler },
                on: { continue: _vm.incrementActiveComponent }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.getComponentId("hearingTestNumbers") === _vm.activeComponent.id
            ? _c("hearing-test-numbers", {
                attrs: {
                  handler: _vm.handler,
                  ht_numbers: _vm.form.data.ht_numbers
                },
                on: {
                  "update:ht_numbers": function($event) {
                    return _vm.$set(_vm.form.data, "ht_numbers", $event)
                  },
                  continue: _vm.incrementActiveComponent
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.getComponentId("hearingTestWords") === _vm.activeComponent.id
            ? _c("hearing-test-words", {
                attrs: {
                  handler: _vm.handler,
                  ht_words: _vm.form.data.ht_words
                },
                on: {
                  "update:ht_words": function($event) {
                    return _vm.$set(_vm.form.data, "ht_words", $event)
                  },
                  continue: _vm.incrementActiveComponent
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.getComponentId("hearingTestResults") === _vm.activeComponent.id
            ? _c("hearing-test-results", {
                attrs: {
                  user: _vm.form.data.user,
                  errors: _vm.form.errors,
                  hasHearingLoss: _vm.hasHearingLoss
                },
                on: {
                  "update:user": function($event) {
                    return _vm.$set(_vm.form.data, "user", $event)
                  },
                  continue: _vm.incrementActiveComponent
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.getComponentId("hearingTestPlayer") === _vm.activeComponent.id
            ? _c("hearing-test-player", {
                attrs: { handler: _vm.handler, ht: _vm.form.data.ht },
                on: {
                  "update:ht": function($event) {
                    return _vm.$set(_vm.form.data, "ht", $event)
                  },
                  continue: _vm.incrementActiveComponent
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.getComponentId("contactRequestForm") === _vm.activeComponent.id
            ? _c("contact-request-form", {
                attrs: {
                  user: _vm.form.data.user,
                  errors: _vm.form.errors,
                  hasHearingLoss: _vm.hasHearingLoss,
                  isSubmiting: _vm.isSubmiting
                },
                on: {
                  "update:user": function($event) {
                    return _vm.$set(_vm.form.data, "user", $event)
                  },
                  continue: _vm.submit
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.getComponentId("contactRequestFormNoResults") ===
          _vm.activeComponent.id
            ? _c("contact-request-form-no-results", {
                attrs: {
                  user: _vm.form.data.user,
                  errors: _vm.form.errors,
                  hasHearingLoss: _vm.hasHearingLoss,
                  isSubmiting: _vm.isSubmiting
                },
                on: {
                  "update:user": function($event) {
                    return _vm.$set(_vm.form.data, "user", $event)
                  },
                  continue: _vm.submit
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.getComponentId("goodbye") === _vm.activeComponent.id
            ? _c("good-bye")
            : _vm._e(),
          _vm._v(" "),
          _vm.getComponentId("goodbyeWithResults") === _vm.activeComponent.id
            ? _c("good-bye-with-results", {
                attrs: { hasHearingLoss: _vm.hasHearingLoss }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }